{
  "welcome.title": "Votre enfant a tant à dire",
  "welcome.body": "Répondez à quelques questions rapides et Timo créera un plan personnalisé et gratuit pour aider votre enfant à trouver sa voix. Cela prend environ 90 secondes.",
  "welcome.cta": "Commencer maintenant",
  "age.question": "Quel âge a votre enfant ?",
  "age.sub": "Pour que Timo pose les bonnes questions à son stade.",
  "age.opt.under3": "Moins de 3 ans",
  "age.opt.3-4": "3-4",
  "age.opt.5-6": "5-6",
  "age.opt.7+": "7+",
  "gender.question": "Votre enfant est-il un garçon ou une fille ?",
  "gender.opt.boy": "Garçon",
  "gender.opt.girl": "Fille",
  "name.question": "Quel est le prénom de votre enfant ?",
  "name.sub": "Ou un surnom, pour que Timo puisse rendre l'expérience plus personnelle.",
  "name.placeholder": "Le prénom de votre enfant",
  "words.question": "Environ combien de mots {name} peut-il dire ?",
  "words.sub": "Une estimation approximative est parfaite.",
  "words.opt.0": "0 mot",
  "words.opt.1-5": "1-5 mots",
  "words.opt.6-10": "6-10 mots",
  "words.opt.11-50": "11-50 mots",
  "words.opt.50+": "50+ mots",
  "words.opt.unsure": "Pas sûr",
  "sentences.question": "{name} fait-il des phrases plus longues (4-6 mots) avec une grammaire globalement correcte ?",
  "sentences.opt.yes": "Oui",
  "sentences.opt.no": "Non",
  "delay_fact.title": "Commencer tôt fait la plus grande différence",
  "delay_fact.body": "Quelques minutes par jour avec Timo, et {name} l'attend avec impatience.",
  "delay_fact.cta": "Continuer",
  "calc.title": "Création du profil de communication de {name}",
  "calc.arr.0": "Compréhension des besoins de {name}...",
  "calc.arr.1": "Comparaison avec les étapes de développement...",
  "calc.arr.2": "Sélection des bonnes activités...",
  "calc.arr.3": "Presque prêt...",
  "calc.review.text": "Mon fils est passé de quelques mots à de courtes phrases. Timo lui a donné l'envie de parler.",
  "calc.review.author": "Rasa, maman d'un enfant de 4 ans",
  "score.title": "Le profil de communication de {name}",
  "score.arr.0": "Parole",
  "score.arr.1": "Compréhension",
  "score.arr.2": "Conversation",
  "score.arr.3": "Confiance",
  "score.arr.4": "Social",
  "score.cta": "Créer le plan de {name}",
  "voice.question": "Choisissez la voix Timo de {name}",
  "voice.sub": "Touchez une carte pour écouter un extrait.",
  "email.title": "Créez votre compte gratuit",
  "email.sub": "Cela permet de sauvegarder le plan de {name} et de vous reconnecter à tout moment.",
  "conversation.question": "{name} peut-il tenir une conversation sans trop d'aide d'un adulte ?",
  "conversation.opt.yes": "Oui",
  "conversation.opt.no": "Non",
  "questions.question": "{name} aime-t-il poser beaucoup de questions, comme “Pourquoi pleut-il ?”",
  "questions.opt.yes": "Oui",
  "questions.opt.no": "Non",
  "find_words.question": "{name} a-t-il parfois du mal à trouver ses mots sur le moment ?",
  "find_words.opt.yes": "Oui",
  "find_words.opt.no": "Non",
  "sounds.question": "Quels sons {name} peut-il prononcer clairement ?",
  "sounds.sub": "Cochez tout ce qui correspond - cela aide Timo à choisir les bons exercices.",
  "sounds.opt.p_b": "P, B  (pomme, bateau)",
  "sounds.opt.m_n": "M, N  (maison, nez)",
  "sounds.opt.t_d": "T, D  (train, dent)",
  "sounds.opt.k_g": "K, G  (cadeau, gare)",
  "sounds.opt.f_v": "F, V  (fleur, vache)",
  "sounds.opt.s_z": "S, Z  (soleil, zèbre)",
  "sounds.opt.l": "L  (loup)",
  "sounds.opt.r": "R  (renard)",
  "sounds.opt.sh_ch": "SH, CH  (chat, chocolat)",
  "therapist.question": "{name} a-t-il déjà consulté un orthophoniste ?",
  "therapist.opt.yes": "Oui",
  "therapist.opt.no": "Non",
  "diagnosis.question": "{name} a-t-il reçu un diagnostic ?",
  "diagnosis.sub": "Ceci reste privé et aide uniquement Timo à personnaliser l'expérience.",
  "diagnosis.opt.autism": "Autisme / TSA",
  "diagnosis.opt.speech_delay": "Retard de parole ou de langage",
  "diagnosis.opt.adhd": "TDAH",
  "diagnosis.opt.none": "Aucun diagnostic",
  "diagnosis.opt.prefer_not": "Je préfère ne pas le dire",
  "social.question": "{name} trouve-t-il les situations de groupe ou sociales difficiles ?",
  "social.opt.yes": "Oui",
  "social.opt.no": "Non",
  "goals.question": "Comment Timo peut-il le plus aider {name} ?",
  "goals.sub": "Choisissez-en jusqu'à 3 - cela façonne tout le plan.",
  "goals.opt.confidence": "Renforcer la confiance en parlant",
  "goals.opt.conversations": "Pratiquer les conversations du quotidien",
  "goals.opt.social": "Gérer les moments sociaux délicats",
  "goals.opt.feelings": "Exprimer ses sentiments sainement",
  "goals.opt.calm": "Rester calme face au stress",
  "goals.opt.school": "Se préparer pour l'école",
  "topics.question": "Choisissez les thèmes préférés de {name}",
  "topics.sub": "Timo les intègre dans les exercices.",
  "topics.opt.animals": "Animaux",
  "topics.opt.space": "Espace",
  "topics.opt.vehicles": "Véhicules",
  "topics.opt.music": "Musique",
  "topics.opt.nature": "Nature",
  "topics.opt.food": "Nourriture",
  "experts.title": "Conçu avec des experts, adapté à {name}",
  "experts.body": "Timo Helps s'appuie sur une méthode de communication autour de l'autisme et de la parole, puis s'adapte aux réponses de {name} - jamais de taille unique.",
  "experts.quote.text": "Plus de 10 000 familles utilisent Timo Helps pour aider leur enfant à trouver sa voix.",
  "experts.quote.author": "Note moyenne de 4.8",
  "experts.cta": "Voir le plan de {name}",
  "learn_style.question": "Quelle est la façon préférée d'apprendre de {name} ?",
  "learn_style.opt.hands_on": "Faire des activités manuelles",
  "learn_style.opt.stories": "Écouter des histoires",
  "learn_style.opt.video": "Regarder des vidéos",
  "learn_style.opt.games": "Jouer à des jeux",
  "strengths.question": "Quels sont les points forts de {name} ?",
  "strengths.sub": "Choisissez tout ce qui lui correspond.",
  "strengths.opt.creative": "Créatif",
  "strengths.opt.curious": "Curieux",
  "strengths.opt.caring": "Attentionné",
  "strengths.opt.determined": "Déterminé",
  "strengths.opt.funny": "Drôle",
  "challenge.question": "Quel est le plus grand défi de {name} en ce moment ?",
  "challenge.opt.frustrated": "Se frustre facilement",
  "challenge.opt.distracted": "Facilement distrait",
  "challenge.opt.shy": "Timide ou anxieux avec les autres",
  "challenge.opt.overwhelmed": "Se sent vite dépassé",
  "daily_time.question": "Quelle durée de pratique semble réaliste chaque jour ?",
  "daily_time.sub": "Même quelques minutes s'accumulent vite.",
  "daily_time.opt.5": "Petit coup de pouce",
  "daily_time.hint.5": "5 min par jour",
  "daily_time.opt.10": "Juste ce qu'il faut",
  "daily_time.hint.10": "10 min par jour",
  "daily_time.opt.20": "Super boosté",
  "daily_time.hint.20": "20 min par jour",
  "when.question": "Quand {name} va-t-il s'entraîner ?",
  "when.opt.morning": "Le matin",
  "when.hint.morning": "Un démarrage en douceur",
  "when.opt.afternoon": "L'après-midi",
  "when.hint.afternoon": "Un coup de pouce en milieu de journée",
  "when.opt.evening": "Le soir",
  "when.hint.evening": "Se calmer avant le coucher",
  "who_uses.question": "Qui va utiliser Timo Helps avec {name} ?",
  "who_uses.opt.mom": "Maman",
  "who_uses.opt.dad": "Papa",
  "who_uses.opt.grandparent": "Un grand-parent",
  "who_uses.opt.specialist": "Un thérapeute ou professeur",
  "who_uses.opt.themselves": "Tout seul",
  "timeline.question": "Dans combien de temps voulez-vous voir des progrès ?",
  "timeline.opt.weeks": "Dans quelques semaines",
  "timeline.opt.1-2m": "Dans 1-2 mois",
  "timeline.opt.no_rush": "Pas de calendrier strict",
  "main_goal.question": "Quel est votre objectif principal en ce moment ?",
  "main_goal.opt.catch_up": "Aider {name} à rattraper son retard",
  "main_goal.opt.on_track": "Maintenir les progrès sur la bonne voie",
  "main_goal.opt.confidence": "Renforcer la confiance de {name}",
  "main_goal.opt.other": "Autre chose",
  "profile_done.title": "Le plan complet de {name} est prêt",
  "profile_done.body": "Timo a tout ce qu'il faut. Commençons à nous entraîner ensemble.",
  "profile_done.cta": "Commencer l'entraînement"
}
